// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import { router } from './router'
import vuetify from './plugins/vuetify'


Vue.config.productionTip = false


/* eslint-disable no-new */
new Vue({
  router,
  vuetify,
  render: h => h(App),
  template: '<App/>'
}).$mount('#app')
